import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataGridView, useSub, usePub } from "@neumetric/blueprint-lib/components";
import { mitigatorActions, getThreatsByStatus } from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const threatColumns = [
  {
    dataIndex: "threat_id",
    typeRepresentation: "LINK",
    title: "Threat ID",
    width: "15%",
  },
  {
    dataIndex: "source",
    typeRepresentation: "TEXT",
    title: "Source",
    width: "15%",
    showTooltip: true,
  },
  {
    dataIndex: "threat",
    typeRepresentation: "TEXT",
    title: "Threat",
    width: "15%",
    showTooltip: true,
  },
  {
    dataIndex: "threat_type",
    typeRepresentation: "TEXT",
    title: "Threat Type",
    width: "15%",
    showTooltip: true,
  },
  {
    dataIndex: "description",
    typeRepresentation: "TEXT",
    title: "Threat Description",
    searchMode: "SERVER",
    width: "40%",
    showTooltip: true,
    semantics: {
      ellipsisFlag: true,
    },
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "active";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorThreatTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const [tableSelectedKeys, setTableSelectedKeys] = React.useState([]);

  const publish = usePub();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _ref = React.useRef(null);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });
  const threatList = useSelector(getThreatsByStatus.bind(null, state.activeSubmenu.toLowerCase())) || [];

  useEffect(() => {
    fetchThreats();
  }, []);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });
  useSub("MITIGATOR_CLEAR_TABLE_SELECTION", () => {
    setTableSelectedKeys([]); // CLEAR CHECKBOXES VISUALLY
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };

    options.columns = threatColumns;
    options.className = "w-800-px";

    return options;
  }, [state.activeSubmenu]);
  console.log("threatColumns", threatColumns);

  const fetchThreats = () => {
    dispatch(mitigatorActions.fetchThreats());
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchThreats();
  };

  return (
    <div className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`} ref={_ref}>
      <DataGridView
        rowKey="key"
        columns={dvgOptions.columns}
        dataSource={threatList.map((threat) => ({
          key: threat.id,
          threat_id: threat.threat_id,
          id: threat.id,
          source: threat.source ? threat.source : "",
          threat: threat.threat,
          threat_type: threat.threat_type ? threat.threat_type : "",
          description: threat.description,
        }))}
        pagination={{
          pageSize: 9,
          totalCount: threatList.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          if (column.dataIndex === "threat_id") {
            return {
              onLinkClick: () => {
                const p = new URLSearchParams(window.location.search);
                p.set("tab", (state.activeSubmenu || "active").toLowerCase());
                p.set("open", "view-panel");
                p.set("id", record.id);
                p.set("_ts", Date.now());

                navigate(`${window.location.pathname}?${p.toString()}`);
              },
            };
          }
          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">There are no {state.activeSubmenu.toLowerCase()} threats right now!</span>
        }
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: tableSelectedKeys,
          onChange: (selectedRowKeys) => {
            setTableSelectedKeys(selectedRowKeys);
            publish("MITIGATOR_SELECTED_THREAT_IDS", { ids: selectedRowKeys });
          },
        }}
      />
    </div>
  );
};
